import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`This action sets, overwrites, or removes any existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/custom-fields"
        }}>{`custom`}</a>{` field for an existing `}<inlineCode parentName="p">{`billingAddress`}</inlineCode>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setBillingAddressCustomField"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{` - String - Required`}<br parentName="li"></br>
          {`The name of the Custom Field to set`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`value`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/custom-fields#customfieldvalue"
          }}>{`CustomFieldValue`}</a>{` - Optional`}<br parentName="li"></br>
          {`Specifies the format of the value of the Custom Field defined by `}<inlineCode parentName="li">{`name`}</inlineCode>{`. If `}<inlineCode parentName="li">{`value`}</inlineCode>{` is absent or `}<inlineCode parentName="li">{`null`}</inlineCode>{`, the field specified by `}<inlineCode parentName="li">{`name`}</inlineCode>{`, if it exists, is removed. Trying to remove a field that does not exist will fail with an `}<a parentName="li" {...{
            "href": "/api/../api/errors#general-400-invalid-operation"
          }}>{`InvalidOperation`}</a>{` error.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      